import { useAccount } from "@azure/msal-react";
import { Client } from "@microsoft/microsoft-graph-client"
import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import LogoutButton from "./LogoutButton";
import logo from "../images/healthequity-logo-white.svg";
import { Avatar } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import Routes from "./Routes";

const useStyles = makeStyles({
  appBar: {
    backgroundColor: "#fff !important",
    color: "#474747 !important",
  },
  toolBar: {
    paddingLeft: "0 !important",
    height: "90px",
  },
  logoBox: {
    backgroundColor: "#592C82",
    height: "100%",
    width: "280px",
    textAlign: "center",
    "& a": {
      display: "inline-block",
      width: "100%",
    },
  },
  logo: {
    height: "100%",
    verticalAlign: "middle",
    display: "inline-block",
    width: "190px",
    margin: "0 auto",
  },
  user: {
    fontFamily: "Lato",
    color: "#474747",
    fontWeight: 400,
  },
  avatar: {
    backgroundColor: "#474747 !important",
    marginLeft: "16px",
  },
});

function NavBar({ graphClient } : { graphClient: Client | undefined }) {
  const classes = useStyles();
  const accountInfo = useAccount();
  const [profileImage, setProfileImage] = useState("");

  useEffect(() => {
    if (graphClient === undefined) {
      setProfileImage("");
    }
    else {
      graphClient.api('/me/photo/$value').get().then(image => {
        const url = window.URL;
        setProfileImage(url.createObjectURL(image));
      }).catch(_ => {
        setProfileImage("");
      })
    }
  }, [graphClient]);

  return (
    <AppBar className={classes.appBar} position="static">
      <Toolbar className={classes.toolBar} variant="dense">
        <Box
          className={classes.logoBox}
          sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
        >
          <Link to={Routes.home}>
            <img className={classes.logo} alt="HealthEquity Logo" src={logo} />
          </Link>
        </Box>
        <Box sx={{ flexGrow: 1 }}></Box>
        {accountInfo && (
          <>
            <LogoutButton />
            <span className={classes.user}>{accountInfo.name}</span>
            <Avatar
              alt={accountInfo.name}
              src={profileImage}
              className={classes.avatar}
            ></Avatar>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default NavBar;
